<template>
    <div class="">
        <van-nav-bar title="机构入驻申请" />
        <div class="apply orange">
            <van-form @submit="onSubmit" :disabled="preview" @failed="onFormFailed">
                <div class="title">入驻平台</div>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="form.terrace"
                    label=" 入驻平台"
                    placeholder="点击选择入驻平台(必填)"
                    @click="selectPlatform"
                    required
                    :rules="[{ required: true, message: '请填写入驻平台' }]"
                />
                <div class="tip orange">提示：申请成功后入驻平台不可修改</div>
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                        :readonly="!isAdd"
                        show-toolbar
                        :columns="columns"
                        value-key="name"
                        required
                        ref="columnsPicker"
                        @confirm="terraceChange"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <div class="title">基本信息</div>
                <van-field name="uploader" label="机构LOGO" required :rules="[{ required: true, message: '请选择机构LOGO' }]">
                    <template #input>
                        <van-uploader
                            accept="*"
                            :before-read="beforeRead"
                            v-model="form.logodev"
                            :after-read="afterRead"
                            :deletable="!preview"
                            :show-upload="!preview"
                            :max-count="1"
                            :max-size="10 * 1024 * 1024"
                            @oversize="onOversize"
                        />
                    </template>
                </van-field>
                <div class="tip orange">提示：请上传格式为JPG/PNG,小于10M的图片</div>
                <van-field
                    v-model="form.simpleName"
                    name="simpleName"
                    required
                    label="商家简称"
                    placeholder="请输入商家简称(必填)"
                    :rules="[{ required: true, message: '商家简称' }]"
                />
                <van-field
                    v-model="form.fullName"
                    required
                    autosize
                    type="textarea"
                    name="fullName"
                    label="商家全称"
                    placeholder="请输入"
                    :rules="[{ required: true, message: '请输入商家全称' }]"
                />
                <van-field
                    autocomplete="off"
                    name="checkboxGroup"
                    required
                    label="商家类型"
                    placeholder="点击选择标签"
                    :rules="[{ required: true, message: '请点击选择商家类型' }]"
                    v-model="form.type"
                    @click="showPopup"
                >
                </van-field>
                <van-popup v-model="showtype" closeable close-icon="close" position="bottom" :style="{ height: '60%' }">
                    <div class="typeTop"></div>
                    <div class="typeContent" v-for="(it, ix) in storeType" :key="ix">
                        <div class="title">{{ it.labelName }}</div>
                        <div class="btn">
                            <van-button
                                native-type="button"
                                v-for="(item, index) in it.child"
                                :key="index"
                                :disabled="item.disabled"
                                :class="['list', item.change ? 'che' : '']"
                                @click.stop="changeType(item, it)"
                                >{{ item.labelName }}</van-button
                            >
                        </div>
                    </div>
                </van-popup>

                <van-field
                    v-model="form.orgCode"
                    name="orgCode"
                    label="统一社会信用代码"
                    required
                    placeholder="请输入(必填)"
                    :rules="[{ required: true, validator: orgCodeValidator, message: '请输入统一社会信用代码' }]"
                />
                <van-field
                    v-model="form.businessScope"
                    name="businessScope"
                    required
                    label="经营范围"
                    autosize
                    type="textarea"
                    placeholder="请输入"
                    :rules="[{ required: true, message: '请输入经营范围' }]"
                />
                <van-field
                    readonly
                    clickable
                    required
                    name="calendar"
                    :value="form.registerTime"
                    label="注册/成立时间"
                    placeholder="点击选择注册/成立时间"
                    @click="registrationTime"
                    :rules="[{ required: true, message: '请点击选择注册/成立时间' }]"
                />
                <van-calendar
                    v-model="showCalendar"
                    ref="calendar"
                    required
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirmTime"
                />
                <van-field
                    v-model="form.legalPerson"
                    name="legalPerson"
                    required
                    label="法人/经营者"
                    placeholder="请输入法人/经营者(必填)"
                    :rules="[{ required: true, message: '请输入法人/经营者' }]"
                />
                <van-field
                    v-model="form.address"
                    name="address"
                    required
                    label="商家地址"
                    placeholder="请输入商家地址"
                    :rules="[{ required: true, message: '请输入商家地址间' }]"
                />
                <div class="title">商家介绍</div>
                <van-field
                    autocomplete="off"
                    v-model="form.introduction"
                    name="introduction"
                    autosize
                    type="textarea"
                    required
                    label="商家简介"
                    placeholder="请输入商家简介"
                    :rules="[{ required: true, message: '请输入商家简介' }]"
                />
                <van-field name="uploader" label="商家店铺图片" required :rules="[{ required: true, message: '请选择商家店铺图片' }]">
                    <template #input>
                        <van-uploader
                            accept="*"
                            v-model="form.picturesdev"
                            :before-read="beforeRead"
                            :after-read="afterRead2"
                            :before-delete="deleteImg"
                            :deletable="!preview"
                            :show-upload="!preview"
                            :max-count="9"
                            :max-size="10 * 1024 * 1024"
                            @oversize="onOversize"
                            :multiple="false"
                        />
                    </template>
                </van-field>
                <div class="tip orange">提示：请上传格式为JPG/PNG,小于10M的图片，最多9张</div>
                <div class="title">申请人</div>
                <van-field
                    autocomplete="off"
                    v-model="form.chargeName"
                    required
                    name="chargeName"
                    label="联系人"
                    placeholder="请输入姓名(必填)"
                    maxlength="10"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                />
                <van-field
                    readonly
                    autocomplete="off"
                    v-model="form.chargePhone"
                    required
                    name="chargePhone"
                    label="联系电话"
                    placeholder="请输入联系电话(必填)"
                    :rules="[
                        { required: true, message: '请输入联系电话' },
                        { validator: phoneValidator, message: '请输入正确的联系电话' }
                    ]"
                />
                <div style="margin: 16px" v-if="isAdd || !preview">
                    <van-button color="#ff6633" round block type="info" native-type="submit" :loading="submitLoading">提交</van-button>
                </div>
                <div class="dis" v-else>
                    <van-button color="#ff6633" plain type="primary" native-type="button" @click="logOff" class="logOff">
                        注销机构
                    </van-button>
                    <van-button color="#ff6633" type="primary" class="edit" native-type="button" @click="edit" :loading="submitLoading">
                        编辑
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { Dialog, Toast } from 'vant';
import { reqApply, selectDept, selectType, selectIsStore, reqCancellationMechanism } from '../api/index';
export default {
    data() {
        return {
            isAdd: true,
            preview: false,
            show: false,
            form: {
                terrace: '', // 入驻平台
                deptID: '',
                logodev: [],
                logo: [],
                simpleName: '',
                fullName: '',
                type: '',
                typeCopy: [],
                malllabelIds: '',
                orgCode: '',
                businessScope: '', // 经营范围
                registerTime: '', // 成立时间
                legalPerson: '', // 法人
                address: '',
                introduction: '', // 商家介绍
                picturesdev: [],
                pictures: [],
                chargeName: '',
                chargePhone: ''
            },
            columns: [],
            storeType: [],
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(2030, 0, 31),
            showtype: false,
            showPicker: false,
            showCalendar: false,
            mallOrgID: '', // 机构id
            imageuHost: 'https://file.pzhszgh.cn',
            // imageuHost: ''
            submitLoading: false
        };
    },
    methods: {
        beforeRead(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                Toast('请上传 jpg或png 格式图片');
                return false;
            }
            return true;
        },
        // 获取入住平台基础数据
        async getDept() {
            selectDept().then(res => {
                this.columns = res.data.data.map(item => ({ name: item.deptName, id: item.deptID }));
            });
        },
        // 显示入住平台
        selectPlatform() {
            this.showPicker = true;
        },
        // 入住平台确认
        terraceChange(e) {
            this.form.terrace = e.name;
            this.form.deptID = e.id;
            this.showPicker = false;
        },
        // 机构Logo 文件上传完毕后会触发 after-read 回调函数
        afterRead(file) {
            const formData = new FormData();
            formData.append('file', file.file);
            this.$http.post('https://file.pzhszgh.cn/file/upload?module=mall', formData).then(res => {
                this.form.logo = res.data.data.relativePath;
            });
        },
        onOversize(file) {
            Toast('文件大小不能超过10M');
        },
        // 统一社会信用代码校验
        orgCodeValidator(value) {
            const pattern = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
            return pattern.test(value);
        },
        // 验证手机号码
        phoneValidator(value) {
            const pattern = /^1[3456789]\d{9}$/;
            return pattern.test(value);
        },
        // 显示商家类型
        showPopup() {
            this.showtype = true;
        },
        // 获取商家类型
        async getType() {
            selectType().then(res => {
                this.storeType = res.data.data;
                this.storeType.forEach(item => {
                    if (item.child) {
                        item.child.forEach(it => {
                            it.change = false;
                        });
                    }
                });
            });
        },
        // 确认商家类型
        changeType(e, es) {
            // 控制显示
            e.change = !e.change;
            this.$forceUpdate();
            const index = this.form.typeCopy.findIndex(item => e.labelName === item.name);
            if (index === -1) {
                this.form.typeCopy.push({ name: e.labelName, mallLabelID: e.mallLabelID });
            } else {
                this.form.typeCopy.splice(index, 1);
            }
            this.form.type = this.form.typeCopy.map(item => item.name).join(',');
        },
        // 显示注册时间
        registrationTime() {
            this.showCalendar = true;
        },
        // 确认注册时间
        onConfirmTime(date) {
            this.form.registerTime = this.formatDate(date);
            this.showCalendar = false;
        },
        // 格式化时间
        formatDate(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let data = date.getDate();
            month = month < 10 ? '0' + month : month;
            data = data < 10 ? '0' + data : data;
            return `${year}-${month}-${data}`;
        },
        // 商家店铺图片
        afterRead2(file) {
            console.log(file);
            const formData = new FormData();
            formData.append('file', file.file);
            this.$http.post('https://file.pzhszgh.cn/file/upload?module=mall', formData).then(res => {
                this.form.pictures.push({ url: res.data.data.relativePath, name: res.data.data.originalFileName });
                console.log(this.form);
            });
        },
        // 文件删除前的回调函数，返回 false 可终止文件读取，支持返回 Promise
        deleteImg(file) {
            // console.log(file.url.substring(file.url.length - 10));
            // console.log(this.form.pictures[0].url.substring(this.form.pictures[0].url.length - 10));
            // console.log(file);
            if (this.isAdd) {
                for (let i = 0, len = this.form.pictures.length; i < len; i++) {
                    if (file.file.name === this.form.pictures[i].name) {
                        this.form.pictures.splice(i, 1);
                        this.form.picturesdev.splice(i, 1);
                        break;
                    }
                }
            } else {
                for (let i = 0, len = this.form.pictures.length; i < len; i++) {
                    if (
                        file.url.substring(file.url.length - 10) ===
                        this.form.pictures[i].url.substring(this.form.pictures[i].url.length - 10)
                    ) {
                        // console.log(this.form.pictures[i].url.substring(this.form.pictures[i].url.length - 10));
                        this.form.pictures.splice(i, 1);
                        this.form.picturesdev.splice(i, 1);
                        break;
                    }
                }
            }
        },
        // 表单验证失败通知
        onFormFailed(errorInfo) {
            Toast(errorInfo.errors[0].message);
        },
        // 提交或编辑申请
        async onSubmit(values) {
            this.form.malllabelIds = this.form.typeCopy.map(item => item.mallLabelID).join(',');
            this.form.pictures.map(e => {
                delete e.name;
            });
            const parame = { ...this.form, pictures: JSON.stringify(this.form.pictures) };
            this.submitLoading = true;
            if (this.isAdd) {
                // 添加
                const res = await reqApply(parame);
                // console.log(parame, res);
                if (res.result === 200) {
                    this.$toast({
                        message: '申请成功，待管理员审批，3秒后返回申请页',
                        position: 'center'
                    });
                    // this.form = {};
                    setTimeout(() => {
                        this.$router.push('/store');
                    }, 3000);
                } else {
                    this.$toast({
                        message: res.message,
                        position: 'center'
                    });
                    // this.form = {};
                }
                this.submitLoading = false;
            } else {
                // 编辑
                reqCancellationMechanism({ mallOrgID: this.mallOrgID, ...parame })
                    .then(res => {
                        if (res.result === 200) {
                            this.$toast({
                                message: '修改成功，待管理员审批',
                                position: 'center'
                            });
                            this.$router.go(-1);
                        } else {
                            this.$toast({
                                message: res.message,
                                position: 'center'
                            });
                        }
                    })
                    .finally(() => {
                        this.submitLoading = false;
                    });
            }
        },
        // 获取商家信息
        getMerchantData() {
            selectIsStore({ phone: this.$globalData.phone1 })
                .then(res => {
                    const {
                        mallOrgID,
                        deptID,
                        logo,
                        simpleName,
                        fullName,
                        orgCode,
                        businessScope,
                        registerTime,
                        legalPerson,
                        address,
                        introduction,
                        pictures,
                        chargeName,
                        chargePhone,
                        malllabelList
                    } = res.data.mallorg;
                    this.mallOrgID = mallOrgID;
                    this.form.deptID = deptID;
                    this.form.logo = logo;
                    this.form.logodev = [{ url: this.imageuHost + logo }];
                    this.form.simpleName = simpleName;
                    this.form.fullName = fullName;
                    this.form.malllabelIds = malllabelList.map(item => item.mallLabelID);
                    this.form.orgCode = orgCode;
                    this.form.businessScope = businessScope;
                    this.form.registerTime = registerTime;
                    this.$refs.calendar.reset(moment(this.form.registerTime).toDate());
                    this.form.legalPerson = legalPerson;
                    this.form.address = address;
                    this.form.introduction = introduction;
                    this.form.chargeName = chargeName;
                    this.form.chargePhone = chargePhone;
                    this.form.picturesdev = JSON.parse(pictures).map(item => ({ url: this.imageuHost + item.url }));
                    this.form.pictures = JSON.parse(pictures);
                    // 回显入住平台
                    this.columns.forEach(item => {
                        if (item.id === deptID) {
                            this.form.terrace = item.name;
                        }
                    });

                    // 商家类型
                    this.form.type = malllabelList.map(item => item.labelName).join(',');
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 注销机构
        logOff() {
            Dialog.confirm({
                title: '提示',
                confirmButtonColor: '#ee0a24', // 确认按钮上文字的颜色，默认为#ee0a24
                message: '注销机构将清除所有机构信息且不可恢复，确认注销吗？' // 二次弹框的message内容
            })
                .then(() => {
                    // 点确定后执行这里
                    reqCancellationMechanism({ status: 1, mallOrgID: this.mallOrgID }).then(res => {
                        if (res.result === 200) {
                            this.$toast({
                                message: '注销成功',
                                position: 'center'
                            });
                            this.$router.go(-1);
                        } else {
                            this.$toast({
                                message: res.message,
                                position: 'center'
                            });
                        }
                    });
                })
                .catch(() => {
                    // 点取消后执行这里
                });
        },
        // 编辑
        edit() {
            this.preview = false;
            // 回显商家类型
            this.storeType.forEach(item => {
                item.child &&
                    item.child.map(c => {
                        // 当前项需要回显
                        if (this.form.malllabelIds.indexOf(c.mallLabelID) !== -1) {
                            c.change = true;
                            this.form.typeCopy.push({ name: c.labelName, mallLabelID: c.mallLabelID });
                        }
                    });
            });
        }
    },
    mounted() {
        this.getDept();
        this.getType();
        this.isAdd = this.$route.query.isAdd === 'true';
        if (this.isAdd) {
            this.form.chargePhone = this.$globalData.phone1;
        } else {
            this.preview = true;
            this.getMerchantData(); // 编辑
        }
    }
};
</script>

<style lang="scss" scoped>
.orange {
    color: #ff6633;
}
.title {
    font-size: 18px;
    font-weight: 600;
}
.tip {
    font-size: 14px;
    margin-bottom: 10px;
}
.apply {
    padding: 10px 20px;
}
// .van-cell {
//     padding: 0.26667rem 0.12667rem;
// }
.typeTop {
    height: 50px;
}
.typeContent {
    margin: 0 auto;
    margin-bottom: 10px;
    padding: 10px;
    width: 350px;
    font-size: 16px;
    border-radius: 10px;
    background: #f8f8f8;
    min-height: 50px;
    .title {
        width: 100px;
    }
    .btn {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
    }
    .list {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 25px;
        margin: 0 10px 10px 0;
        background-color: #fff;
        border-radius: 10px;
        color: #111;
        border: #a09c9c solid 2px;
    }
    .che {
        background: #ff6633;
        border: 2px solid #ff6633;
        color: white;
    }
}
.dis {
    display: flex;
    justify-content: space-between;
    .logOff {
        width: 130px;
    }
    .edit {
        width: 200px;
    }
}
</style>
